<template>
  <v-list-group v-model="showLanguageMenu">
    <v-list-tile slot="activator">
      <v-list-tile-title>Limba</v-list-tile-title>
    </v-list-tile>
    <template v-for="(lang, i) in languages">
      <v-divider v-if="i > 0"></v-divider>
      <v-list-tile :disabled="language === lang.short"  :key="lang.short" @click="setLanguage(lang.short)">
        <v-list-tile-title>{{ lang.flag }} {{ lang.long | ucfirst }}</v-list-tile-title>
      </v-list-tile>
    </template>
  </v-list-group>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    data() {
      return {
        showLanguageMenu: true
      }
    },
    computed: {
      ...mapGetters(['language', 'languages'])
    },
    filters: {
      ucfirst: s => s[0].toLocaleUpperCase() + s.slice(1)
    },
    methods: {
      ...mapActions(['setLanguage'])
    }
  }
</script>
